import { useEffect, useState }  from 'react';

function useHeader(props, headerRef) {
    const { refs } = props;

    const [ isSticked, setSticked ] = useState(false);

    useEffect(() => {
        setSticked(headerRef.current.offsetTop !== 0);
        
        document.addEventListener("scroll", scrollListener);

        return function cleanup() {
            document.removeEventListener('scroll', scrollListener)
        }
    }, [])

    function scrollListener() {
        setSticked(headerRef.current.offsetTop !== 0);
    }

    function handleScrollTo(name) {
        return () => {
            refs[name].current.scrollIntoView({
                behavior: 'smooth',
                block: 'center'
            });
        }
    }

    return {
        handleScrollTo,
        isSticked
    };
}

export default useHeader;
